import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { semenKeys } from '../queries/keys';
import { semenPaths } from '../queries/paths';

// TSS vite/03 — server-state hooks for semen (api-reference/admin-semen.md).
// Reads embed `race`. Sire is own (sire_animal_id) XOR external (sire_name).

export function useSemenList(filters, { enabled = true } = {}) {
    return useQuery({
        queryKey: semenKeys.list(filters),
        queryFn:  ({ signal }) => api.get(semenPaths.list(), { params: filters, signal }).then(r => r.data),
        placeholderData: (prev) => prev,
        enabled,
    });
}

export function useSemen(id) {
    return useQuery({
        queryKey: semenKeys.detail(id),
        queryFn:  ({ signal }) => api.get(semenPaths.detail(id), { signal }).then(r => r.data),
        enabled:  !!id && id !== 'new',
    });
}

export function useCreateSemen() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(semenPaths.list(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: semenKeys.all }),
    });
}

export function useUpdateSemen(id) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.patch(semenPaths.detail(id), payload).then(r => r.data),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: semenKeys.detail(id) });
            qc.invalidateQueries({ queryKey: semenKeys.all });
        },
    });
}

export function useDeleteSemen() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.delete(semenPaths.detail(id)).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: semenKeys.all }),
    });
}
